import { render, staticRenderFns } from "./OnzeHonden.vue?vue&type=template&id=07a36de1"
import script from "./OnzeHonden.vue?vue&type=script&lang=js"
export * from "./OnzeHonden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports